import React from 'react';
import onConnexLogo from '../assets/images/ON-Connex.png';
import onIgoLogo from '../assets/images/ON-iGO.png';


function Footer() {
  return (
    <footer className="footerSec" id="footerId">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="footerLogosRow">
              <div className="footerLogoWrap footerLogoLeft">
                <img src={onConnexLogo} alt="Connex Ontario" className="footerLogoImage" />
              </div>
              <div className="footerCopyBlock">
                <p className="f-16 w-500 text-center f-white br-16 mustSection">
                  Jackpotify receives compensation from partner links on this page. Winnings are not guaranteed, and you may lose all of your wagered funds. If you or someone you know has a gambling problem, call 1-866-531-2600, text 247247, or chat online at <a href="https://www.connexontario.ca" target="_blank" rel="noopener noreferrer">www.connexontario.ca</a>.
                </p>
                <p className="f-16 w-500 text-center f-white br-16 mustSection">Must be 19+. Please play responsibly.</p>
              </div>
              <div className="footerLogoWrap footerLogoRight">
                <img src={onIgoLogo} alt="iGO Ontario" className="footerLogoImage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
